import React from 'react';
import type { SnapZone } from '../../types';
import { TASKBAR_HEIGHT } from '../../utils/constants';
import styles from './SnapPreview.module.css';

interface SnapPreviewProps {
  zone: SnapZone;
}

export const SnapPreview: React.FC<SnapPreviewProps> = ({ zone }) => {
  if (!zone) return null;

  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight - TASKBAR_HEIGHT;

  let style: React.CSSProperties = {};

  switch (zone) {
    case 'left':
      style = {
        left: 0,
        top: 0,
        width: screenWidth / 2,
        height: screenHeight,
      };
      break;
    case 'right':
      style = {
        left: screenWidth / 2,
        top: 0,
        width: screenWidth / 2,
        height: screenHeight,
      };
      break;
    case 'maximize':
      style = {
        left: 0,
        top: 0,
        width: screenWidth,
        height: screenHeight,
      };
      break;
    default:
      return null;
  }

  return (
    <div className={styles.snapPreview} style={style}>
      <div className={styles.snapPreviewInner} />
    </div>
  );
};

export default SnapPreview;
